<span class="team" [class.is_spoilable]="is_spoilable()">
	<span class="bg" *ngIf="t.color" [style.background]="'#'+t.color"></span>
	<img [src]="t.logo" [alt]="t.abbreviation" [style.padding.px]="t.padding"/>
	<span class="stats">
		<span class="abbr">{{ t.abbreviation }}</span>
		<span *ngIf="(score() !== null) && !(is_spoilable() && t.settings.delete_spoilers)" class="score">
			<span>{{ score() | number: "2.0" }}</span>
			<i class="material-icons" [style.transform]="transform_style">tag</i>
		</span>
	</span>
</span>
